module.exports = __webpack_public_path__ + "images/content-feature-example-image.svg";